// libraries
import type { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

// material-ui
import type { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
    riskLevel: number;
    riskSteps: number;
    customTheme: ReturnType<typeof useInterstateTheme>;
}
const useStyles = makeStyles<Theme, IProps>((theme) => ({
    root: {
        height: 18,
        borderRadius: 4
    },
    colorPrimary: (props) => ({
        backgroundColor: props.customTheme.tokens.BaseColorGray100
    }),
    bar: (props) => ({
        backgroundColor:
            props.riskLevel < Math.floor(props.riskSteps / 2)
                ? props.customTheme.tokens.BaseColorGreen500
                : props.customTheme.tokens.BaseColorRed500
    }),
    labelWrapper: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1)
    },
    riskLevelWrapper: (props) => ({
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        '& > div': {
            width: 22,
            height: 22,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            [`&:nth-child(${props.riskLevel + 1})`]: {
                borderRadius: 11,
                backgroundColor: theme.palette.text.primary,
                '& *': {
                    color: props.customTheme.tokens.BaseColorWhite
                }
            }
        }
    })
}));

export default useStyles;
